import style from './PatientInfo.module.scss';

import { Field, FieldsRow } from '../Field';
import { translate } from '@chaika/i18n/helper';
import { AssistantPracticeChat } from '@modules/patient/store/ehr/types';

interface PatientInfoProps {
    patientName: string;
    recordNumber: number | string;
    birthDate?: string;
    age: number | string;
    phone: number | string;
    email?: string;
    assistantsChats: AssistantPracticeChat[];
    togglePatientInfoShowing(): void;
    onPatientNameClick(): void;
}

export function PatientInfo({
    patientName,
    recordNumber,
    birthDate,
    age,
    phone,
    email,
    togglePatientInfoShowing,
    onPatientNameClick,
}: PatientInfoProps): React.ReactElement<any> {
    return (
        <div className={style.root}>
            <div className={style.topLine}>
                <div>
                    <span className={style.recordNumberPrefix}>№</span>
                    <span>{recordNumber}</span>
                </div>
                <div
                    className={style.close}
                    onClick={togglePatientInfoShowing}
                >
                    {translate('close')}
                </div>
            </div>
            <div
                className={style.patientName}
                onClick={onPatientNameClick}
            >
                {patientName}
            </div>
            <div>
                {birthDate && (
                    <FieldsRow>
                        <Field
                            title={translate('birthDate')}
                            value={`${birthDate} ${age}`}
                        />
                    </FieldsRow>
                )}
                <FieldsRow>
                    <Field
                        title={translate('phone')}
                        value={phone}
                    />
                    {email && (
                        <Field
                            title={'E-mail'}
                            value={email}
                        />
                    )}
                </FieldsRow>
            </div>
        </div>
    );
}
